import { Box, Chip } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Container = styled(Box)(({ theme }) => ({
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: 'calc(100vh - 152px)',
  margin: '8px 0px',
  borderRadius: theme.shape.customBorderRadius.main,
  backgroundColor: theme.palette.common.white,

  '& .content': {
    backgroundColor: theme.palette.grey[200], //theme.GREY_OTHER
    padding: '8px',
    margin: '8px 0px',
    '& .text': {
      fontWeight: 400,
      fontSize: '14px',
    },
    '& .title': {
      fontSize: '16px',
      color: theme.palette.text.primary,
      lineHeight: '18px',
      letterSpacing: '0.15px',
      fontWeight: '500',
      marginBottom: 12,
    },
  },

  '& .opt': {
    display: 'flex',
  },

  '& .actions': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0,1fr))',
    gap: '8px',
    margin: '8px 0',

    a: {
      border: `1px solid ${theme.palette.primary.main}`,
      height: '36px',
      borderRadius: theme.shape.customBorderRadius.main,

      fontWeight: 500,
      fontSize: '14px',

      letterSpacing: '0.4px',
      lineHeight: '24px',

      color: theme.palette.primary.main,
      textDecoration: 'none',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },

  '& .person-info': {
    display: 'flex',
    flexDirection: 'column',

    '& .info-title': {
      fontSize: '16px',
      color: theme.palette.text.primary,
      lineHeight: '18px',
      letterSpacing: '0.15px',
      fontWeight: '500',
      marginBottom: '15px',
    },

    '& .top-container': {
      display: 'flex',
      justifyContent: 'space-between',

      '& .MuiChip-root': {
        marginRight: '0px',
      },

      '& .title': {
        fontSize: '16px',
        color: theme.palette.primary.main,
        lineHeight: '18px',
        letterSpacing: '0.15px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        marginBottom: 5,

        // quick hack - Emmanuel
        maxHeight: '38px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        '& .MuiSvgIcon-root': {
          marginRight: '8px',
        },
      },

      '& .address': {
        marginTop: '4px',
        fontSize: '16px',
        fontWeight: 400,
        color: theme.palette.text.primary,
        lineHeight: '24px',
        letterSpacing: '0.15px',
      },
    },

    '& .property-info': {
      marginTop: '12px',
      display: 'flex',
      flexDirection: 'column',

      '& .MuiBox-root': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px',
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.customBorderRadius.main,
        border: `1px solid ${theme.palette.grey[200]}`, //theme.GREY_VARIANT

        ':nth-of-type(even)': {
          border: 'none',
          borderRadius: '2px',
          backgroundColor: theme.palette.background.default,
        },

        '& .MuiTypography-root': {
          fontSize: '0.8rem',
          color: theme.palette.text.primary,
          lineHeight: '24px',
          letterSpacing: '0.15px',
          fontWeight: '400',
        },
      },
    },
  },
}))
